import React from "react";

function Contacts() {
  return (
    <div className="space-y-6">

      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-semibold text-gray-800">Contacts</h1>
          <p className="text-sm text-gray-500">
            Manage all your leads and customers
          </p>
        </div>

        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
          + Add Contact
        </button>
      </div>

      {/* Search */}
      <div className="bg-white rounded-xl shadow-sm p-4">
        <input
          type="text"
          placeholder="Search contacts..."
          className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600 text-left">
            <tr>
              <th className="p-4">Name</th>
              <th>Email</th>
              <th>Company</th>
              <th>Status</th>
              <th>Last Contacted</th>
            </tr>
          </thead>

          <tbody className="divide-y">
            <tr className="hover:bg-gray-50">
              <td className="p-4 font-medium">Rahul Sharma</td>
              <td>rahul@gmail.com</td>
              <td>TechSoft</td>
              <td>
                <span className="bg-green-100 text-green-600 px-2 py-1 rounded-full text-xs">
                  Active
                </span>
              </td>
              <td>2 days ago</td>
            </tr>

            <tr className="hover:bg-gray-50">
              <td className="p-4 font-medium">Priya Patel</td>
              <td>priya@gmail.com</td>
              <td>Marketing Pro</td>
              <td>
                <span className="bg-yellow-100 text-yellow-600 px-2 py-1 rounded-full text-xs">
                  Follow Up
                </span>
              </td>
              <td>5 days ago</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default Contacts;
